import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fill: theme.palette.common.white,
  },
}));

export default useStyles;
